import React, {FC} from 'react'
import CommerciumCartMark from './CommerciumCartMark'
import {
  CommerciumLoaderLayout,
  CommerciumLoaderVariant,
  commerciumCartSizeForVariant,
} from './commerciumLoaderSizes'
import './CommerciumLoader.css'

export type {CommerciumLoaderLayout, CommerciumLoaderVariant}

interface CommerciumLoaderProps {
  message?: string
  subMessage?: string
  variant?: CommerciumLoaderVariant
  /** Branded shell (gradient) for full-page waits; plain for embedded/table/section. */
  layout?: CommerciumLoaderLayout
}

const CommerciumLoader: FC<CommerciumLoaderProps> = ({
  message = 'Loading ...',
  subMessage,
  variant = 'page',
  layout = 'brand',
}) => {
  const cartSize = commerciumCartSizeForVariant(variant)
  const isPlain = layout === 'plain' || variant !== 'page'
  const rootClass = [
    'commercium-wait',
    `commercium-wait--${variant}`,
    isPlain ? 'commercium-wait--plain' : 'commercium-wait--brand',
  ].join(' ')

  const waitContent = (
    <>
      {!isPlain && <div className='commercium-wait__glow' aria-hidden='true' />}
      <CommerciumCartMark size={cartSize} />
      <div className='commercium-wait__copy'>
        {message ? <p className='commercium-wait__message'>{message}</p> : null}
        {subMessage ? <p className='commercium-wait__sub'>{subMessage}</p> : null}
      </div>
    </>
  )

  if (variant === 'table') {
    return (
      <div className='cmm-table-loader-host' role='status' aria-live='polite' aria-busy='true'>
        <div className={rootClass}>{waitContent}</div>
      </div>
    )
  }

  return (
    <div className={rootClass} role='status' aria-live='polite' aria-busy='true'>
      {waitContent}
    </div>
  )
}

export default CommerciumLoader
